import { TFunction } from 'i18next';
import { FieldError } from 'react-hook-form';
import * as yup from 'yup';

export const translateError = (
  error?: FieldError,
  t?: TFunction,
): string | undefined => {
  if (!error || !t) return undefined;
  const msg = error.message;
  if (!msg) return undefined;

  if (msg.startsWith('{')) {
    try {
      const { key, params } = JSON.parse(msg);
      return t(key as string, {
        ...(params as Record<string, unknown>),
        interpolation: { escapeValue: false },
      });
    } catch {
      return t(msg);
    }
  }

  if (msg.includes('|')) {
    const [key, symbol] = msg.split('|');
    return t(key, { symbol, interpolation: { escapeValue: false } });
  }
  return t(msg, { interpolation: { escapeValue: false } });
};

export const createI18nError = (
  ctx: yup.TestContext,
  key: string,
  params?: Record<string, unknown>,
) => {
  return ctx.createError({
    message: JSON.stringify({ key, params }),
    path: ctx.path,
  });
};
